export default __webpack_public_path__ + "static/media/chatIconHC.102453a2.svg";